import ezpay from './ezpay';
import rcp from "./rcp";

export default {
  ezpay,
  rcp
};

